// used for dynamic background colors for PokeCards/modal content
const getTypeColors = {
  normal: "#A8A878",
  fire: "#F08030",
  water: "#6790F0",
  grass: "#78C84F",
  electric: "#F9CF30",
  ice: "#98D8D8",
  fighting: "#C03028",
  poison: "#9F409F",
  ground: "#E0C068",
  flying: "#A890F0",
  psychic: "#F85888",
  bug: "#A8B720",
  rock: "#705898",
  ghost: "#705898",
  dark: "#705848",
  steel: "#B8B8D0",
  fairy: "#F0B6BC",
  dragon: "#7038F8",
};

export default getTypeColors;
